export default __webpack_public_path__ + "static/media/burger.25c5e527.PNG";